module.exports = __webpack_public_path__ + "img/bg1.784888e7.jpg";